<template>
  <v-layout style="padding:20px;">
    <v-flex xs12>
      <v-card flat dense color="white black--text" style="min-height:80VH;">
        <v-card-title class="dark-grey--text subheading">
          <strong>
            <b>Reports List</b>
          </strong>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            outline
            append-icon="search"
            placeholder="Search"
            class="black--text"
            color="black"
            single-line
            hide-details
          ></v-text-field>
          <v-spacer></v-spacer>
           <svg
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            @click="$router.push('/reportDesign')"
            xmlns="http://www.w3.org/2000/svg"
          >
            <title>Add</title>
            <circle cx="11" cy="11" r="11" stroke="#3D56E6" />
            <path
              d="M10.9998 7.69922V15.3992"
              stroke="#3D56E6"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M14.8506 11.55L7.15059 11.55"
              stroke="#3D56E6"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <!-- <v-icon  flat class="icon-color" @click="$router.push('/reportDesign')">add</v-icon> -->
          <FilterDrawer filterKey="reports" v-on:applyFilter="applyFilter" />
          <Help kbCategoryCode="RE" />
          <PrintDocument class="prt" documentName="Report" :headers="headers" :printData="reports" />
        </v-card-title>
        <hr />
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="reports"
            :search="search"
            class="elevation-1"
            select-all
            :pagination.sync="pagination"
            v-model="selected"
          >
            <template slot="items" slot-scope="props">
              <tr>
                <td width="2%">
                  <v-checkbox v-model="props.selected" primary hide-details></v-checkbox>
                </td>
                <td width="5%" class="text-xs-left">{{ props.item.id }}</td>
                <td width="10%" class="text-xs-left">{{ props.item.name }}</td>
                <td width="10%" class="text-xs-left">{{ props.item.data_source }}</td>
                <td width="10%" class="text-xs-left">
                  <v-chip
                    small
                    style="background-color: #2B2F8E"
                    text-color="white"
                  >{{ props.item.active==1? 'Active':'Inactive'}}</v-chip>
                </td>
                <td width="10%">
                  <!-- <v-icon
                    color="grey--text darken"
                    small
                    @click="addReportsToCompany(props.item)"
                  >fas fa-eye</v-icon>&nbsp; -->
                   <svg
                    class="svgIcon2"
                    width="16"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    @click="editItem(props.item)"
                  >
                    <title>Edit</title>
                    <path
                      d="M8.86676 2.9328H2.48878C2.00548 2.9328 1.54198 3.12479 1.20024 3.46653C0.858493 3.80828 0.666504 4.27178 0.666504 4.75508V17.511C0.666504 17.9943 0.858493 18.4578 1.20024 18.7996C1.54198 19.1413 2.00548 19.3333 2.48878 19.3333H15.2447C15.728 19.3333 16.1915 19.1413 16.5333 18.7996C16.875 18.4578 17.067 17.9943 17.067 17.511V11.1331"
                      stroke="#A3A3A3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M15.7003 1.56611C16.0627 1.20364 16.5544 1 17.067 1C17.5796 1 18.0712 1.20364 18.4337 1.56611C18.7962 1.92858 18.9998 2.4202 18.9998 2.93282C18.9998 3.44543 18.7962 3.93705 18.4337 4.29953L9.77786 12.9554L6.1333 13.8665L7.04444 10.2219L15.7003 1.56611Z"
                      stroke="#A3A3A3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <!-- <v-icon color="grey--text darken" small @click="editItem(props.item)">fas fa-edit</v-icon> -->
                </td>
              </tr>
            </template>
          </v-data-table>
          <v-dialog v-model="showDialog" max-width="500px">
            <PublishReports
              v-if="showDialog"
              :reportId="selectedReportId"
              v-on:closeDialog="closeDialog"
            />
          </v-dialog>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import ReportModel from "@/api/service/ReportService";
import PrintDocument from "@/components/PrintComponent.vue";
import PublishReports from "@/components/PublishReports.vue";
import FilterDrawer from "@/components/FilterDrawer.vue";
import Help from "@/components/HelpComponent.vue";
export default {
  props: [],
  components: {
    PrintDocument,
    FilterDrawer,
    PublishReports,
    Help
  },
  data() {
    return {
      selectedReportId: 0,
      search: "",
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 100,
        sortBy: "id",
        totalItems: 0,
        rowsPerPageItems: [1, 2, 4, 8, 16]
      },
      selected: [],
      headers: [
        {
          text: "Id",
          value: "id",
          pwidth: 30,
          width: "5%",
          class: " text-xs-left"
        },
        {
          text: "Name",
          value: "name",
          pwidth: 30,
          width: "10%",
          class: " text-xs-left"
        },
        {
          text: "Source",
          value: "data_source",
          pwidth: 30,
          width: "10%",
          class: " text-xs-left"
        },
        {
          text: "Active",
          value: "active",
          pwidth: 30,
          width: "10%",
          class: " text-xs-left"
        },
        { width: "10%", class: " text-xs-left" }
      ],
      showDialog: false,
      published: [],
      availbleList: [],
      reports: []
    };
  },
  created: function() {
    this.getReports();
  },
  mounted: function() {
    this.setColumnWidth();
  },
  methods: {
    getReports() {
      ReportModel.getReports({})
        .then(response => {
          console.log(response);
          this.setReport(response);
        })
        .catch(error => {
          console.log(error);
        });
    },
    setReport($reports) {
      this.reports = $reports;
    },
    closeDialog() {
      this.showDialog = false;
    },
    applyFilter($filter) {
      ReportModel.getReportFilter($filter)
        .then(response => {
          this.setReport(response);
        })
        .catch(error => {
          console.log(error);
        });
    },
    editItem($item) {
      this.$router.push("/reportDesign?id=" + $item.id);
    },
    addReportsToCompany($item) {
      this.selectedReportId = $item;
      //this.selectedReportName=
      this.showDialog = true;
    },
    setColumnWidth() {
      let $tableId = document.getElementsByClassName(
        "v-datatable v-table v-datatable--select-all theme--light"
      );
      let firstTableCol = $tableId[0]
        .querySelectorAll("tr")[0]
        .querySelectorAll("th");
      firstTableCol[0].style.width = "2%";
      firstTableCol[0].style.minwidth = "2%";
      firstTableCol[0].style.maxwidth = "2%";
      for (let index = 0; index < firstTableCol.length; index++) {
        if (index > 0) {
          firstTableCol[index].style.width = this.headers[index - 1].width;
          firstTableCol[index].style.minwidth = this.headers[index - 1].width;
          firstTableCol[index].style.maxwidth = this.headers[index - 1].width;
        }
      }
    }
  }
};
</script>
<style >
</style>